import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '../constants';
import { ApiResponse, PaginatedResponse, User } from '@/types';

export interface ListUsersParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const departmentService = {
  async list(params: ListUsersParams = {}): Promise<PaginatedResponse<User>> {
    const query = new URLSearchParams();
    if (params.page) query.set('page', String(params.page));
    if (params.limit) query.set('limit', String(params.limit));
    if (params.search) query.set('search', params.search);
    return apiClient.get<PaginatedResponse<User>>(`${API_ENDPOINTS.DEPARTMENTS.LIST}?${query.toString()}`, {
      authenticate: true,
    });
  },

  async details(id: string): Promise<User> {
    const result = await apiClient.get<ApiResponse<User>>(API_ENDPOINTS.DEPARTMENTS.DETAILS(id), {
      authenticate: true,
    });
    return result.data ?? (result as unknown as User);
  },

  async create(payload: Partial<User>): Promise<User> {
    const result = await apiClient.post<ApiResponse<User>>(API_ENDPOINTS.DEPARTMENTS.CREATE, payload, {
      authenticate: true,
    });
    return result.data ?? (result as unknown as User);
  },

  async update(id: string, payload: Partial<User>): Promise<User> {
    const result = await apiClient.put<ApiResponse<User>>(API_ENDPOINTS.DEPARTMENTS.UPDATE(id), payload, {
      authenticate: true,
    });
    return result.data ?? (result as unknown as User);
  },

  async remove(id: string): Promise<void> {
    await apiClient.delete(API_ENDPOINTS.DEPARTMENTS.DELETE(id), { authenticate: true });
  },
};


